import { SetPasswordErrorCodeV1, SetPasswordErrorV1 } from '@vista-digital/ocapi-client';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { CommonErrorCodes } from '../../../../../types/errors/common-error-codes';
import { getMember } from '../../../selectors/member/get-member';
import { LoyaltyDomainError, LoyaltyDomainSpecificErrorCode } from '../../../types/error';
import { assertIsMemberSignedIn } from '../../../utils/assert-is-member-signed-in';
export const updateMemberPassword = async (passwordUpdate, captchaResponse) => {
    assertIsMemberSignedIn(getMember(), 'Cannot update member password');
    try {
        await ocapiClient.instance.v1.loyalty.members.update.setPassword(passwordUpdate, captchaResponse);
    }
    catch (error) {
        throw handleUpdatePasswordError(error);
    }
};
export const handleUpdatePasswordError = (error) => {
    // Unexpected error, rethrow immediately.
    if (!(error instanceof SetPasswordErrorV1)) {
        throw error;
    }
    const errorCode = convertApiToDomainErrorCode(error.errorCode);
    return new LoyaltyDomainError(errorCode, error.message);
};
const convertApiToDomainErrorCode = (errorCode) => {
    switch (errorCode) {
        case SetPasswordErrorCodeV1.InvalidCurrentPassword:
            return LoyaltyDomainSpecificErrorCode.InvalidCurrentPassword;
        default:
            return CommonErrorCodes.UnknownError;
    }
};
//# sourceMappingURL=update-member-password.js.map